"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilters = exports.UrlParserType = exports.FiltersContextProvider = exports.FiltersContext = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _objectSpread3 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _useValuesStoredInParams = require("../../hooks/useValuesStoredInParams/useValuesStoredInParams");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _noop = require("../../utils/noop");
var UrlParserType;
exports.UrlParserType = UrlParserType;
(function (UrlParserType) {
  UrlParserType["NUMBER"] = "NUMBER";
  UrlParserType["DATE"] = "DATE";
  UrlParserType["STRING"] = "STRING";
  UrlParserType["SORT"] = "SORT";
  UrlParserType["ARRAY"] = "ARRAY";
  UrlParserType["ENUM"] = "ENUM";
  UrlParserType["BOOLEAN"] = "BOOLEAN";
})(UrlParserType || (exports.UrlParserType = UrlParserType = {}));
var FiltersContext = /*#__PURE__*/(0, _react.createContext)(new Proxy({}, {
  get: function get() {
    throw new Error('FiltersContext is not provided');
  }
}));
exports.FiltersContext = FiltersContext;
var useFilters = function useFilters() {
  return (0, _react.useContext)(FiltersContext);
};
exports.useFilters = useFilters;
var getParsingFunction = function getParsingFunction(parser) {
  switch (parser) {
    case UrlParserType.STRING:
    case UrlParserType.ENUM:
      {
        return function (value) {
          return value;
        };
      }
    case UrlParserType.DATE:
      {
        return function (value) {
          return new Date(Number(value));
        };
      }
    case UrlParserType.NUMBER:
      {
        return function (value) {
          return parseInt(value);
        };
      }
    case UrlParserType.SORT:
      {
        return function (value) {
          return value;
        };
      }
    case UrlParserType.ARRAY:
      {
        return function (value) {
          return value.split(',');
        };
      }
    case UrlParserType.BOOLEAN:
      {
        return function (value) {
          if (value === 'false') {
            return false;
          }
          return true;
        };
      }
  }
};
var buildFilters = function buildFilters(config, params, setFilters) {
  var result = {};
  Object.keys(config).forEach(function (key) {
    var parsedKey = key;
    var pageParam = params.get(key);
    var parsingFunction = getParsingFunction(config[key].parser);
    var parsedParam = pageParam !== null ? parsingFunction(pageParam) : undefined;

    //We cannot use setFilters before state is set up
    var setValue = setFilters ? function (value) {
      setFilters(function (prevState) {
        if (prevState[parsedKey].value === value) {
          return prevState;
        } else {
          return (0, _objectSpread3.default)((0, _objectSpread3.default)({}, prevState), {}, (0, _defineProperty2.default)({}, parsedKey, (0, _objectSpread3.default)((0, _objectSpread3.default)({}, prevState[parsedKey]), {}, {
            value: value
          })));
        }
      });
    } : _noop.noop;
    result[parsedKey] = {
      value: parsedParam !== undefined && parsedParam !== null ? parsedParam : config[parsedKey].defaultValue,
      set: setValue
    };
  });
  return result;
};
var convertToStoredParams = function convertToStoredParams(filters, config) {
  var result = {};
  Object.keys(filters).forEach(function (key) {
    switch (config[key].parser) {
      case UrlParserType.STRING:
      case UrlParserType.ENUM:
      case UrlParserType.NUMBER:
      case UrlParserType.SORT:
        {
          result[key] = {
            value: filters[key].value,
            defaultValue: config[key].defaultValue
          };
          break;
        }
      case UrlParserType.BOOLEAN:
        {
          result[key] = {
            value: filters[key].value,
            defaultValue: config[key].defaultValue
          };
          break;
        }
      case UrlParserType.DATE:
        {
          var _filters$key$value, _config$key$defaultVa;
          result[key] = {
            value: (_filters$key$value = filters[key].value) === null || _filters$key$value === void 0 ? void 0 : _filters$key$value.getTime(),
            defaultValue: (_config$key$defaultVa = config[key].defaultValue) === null || _config$key$defaultVa === void 0 ? void 0 : _config$key$defaultVa.getTime()
          };
          break;
        }
      case UrlParserType.ARRAY:
        {
          result[key] = {
            value: filters[key].value.join(','),
            defaultValue: config[key].defaultValue.join(',')
          };
          break;
        }
    }
  });
  return result;
};
var buildFilterValues = function buildFilterValues(filters) {
  return Object.fromEntries(Object.entries(filters).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return [key, value.value];
  }));
};
var FiltersContextProvider = function FiltersContextProvider(_ref3) {
  var config = _ref3.config,
    children = _ref3.children;
  var location = (0, _reactRouterDom.useLocation)();
  var params = new URLSearchParams(location.search);
  var _useState = (0, _react.useState)(function () {
      return buildFilters(config, params);
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    filters = _useState2[0],
    _setFilters = _useState2[1];
  (0, _react.useEffect)(function () {
    var newFilters = buildFilters(config, params, _setFilters);
    _setFilters(newFilters);

    // Params are recreated every rerender cause of new URLSearchParams
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config, location]);
  (0, _useValuesStoredInParams.useValuesStoredInParams)(convertToStoredParams(filters, config));
  var contextValue = (0, _react.useMemo)(function () {
    var value = (0, _objectSpread3.default)((0, _objectSpread3.default)({}, filters), {}, {
      setFilters: function setFilters(callback) {
        _setFilters(function (prevState) {
          var newFilters = callback(buildFilterValues(prevState));
          var newState = Object.fromEntries(Object.entries(newFilters).map(function (_ref4) {
            var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
              key = _ref5[0],
              value = _ref5[1];
            var filterKey = key;
            var filterValue = {
              set: prevState[key].set,
              value: value
            };
            return [filterKey, filterValue];
          }));
          return newState;
        });
      }
    });
    return new Proxy(value, {
      get: function get(target, property) {
        if (!target[property]) {
          throw new Error("There is no filter called ".concat(property, " in the FiltersContextProvider"));
        } else {
          return target[property];
        }
      }
    });
  }, [filters]);
  return /*#__PURE__*/_react.default.createElement(FiltersContext.Provider, {
    value: contextValue
  }, children);
};
exports.FiltersContextProvider = FiltersContextProvider;